import { render, staticRenderFns } from "./succes.vue?vue&type=template&id=1f21618e&scoped=true&"
import script from "./succes.vue?vue&type=script&lang=js&"
export * from "./succes.vue?vue&type=script&lang=js&"
import style0 from "./succes.vue?vue&type=style&index=0&id=1f21618e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f21618e",
  null
  
)

export default component.exports